import React, { useState, useEffect } from 'react';
import '../styles/CouponOffer.css';

import Skeleton from 'react-loading-skeleton';

const mockCoupons = [
  { id: 1, code: 'GRAND OFFER', description: 'Grab special offers on all your favorite destinations', discount: 3985 },
  { id: 2, code: 'FEDERALOFFER', description: 'Grab special offers on all your favorite destinations', discount: 2985 },
  { id: 3, code: 'SUMMERDEAL', description: 'Hot summer discounts on selected destinations', discount: 1500 },
  { id: 4, code: 'WEEKENDTRIP', description: 'Special discounts for weekend getaways', discount: 1000 },
];

const CouponsOffers = () => {
  const [coupons, setCoupons] = useState([]);
  const [activeCoupons, setActiveCoupons] = useState({});
  const [visibleCoupons, setVisibleCoupons] = useState(2);
  const [loading, setLoading] = useState(true);
  const [totalDiscount, setTotalDiscount] = useState(0);

  useEffect(() => {
    fetchCoupons();
  }, []);

  useEffect(() => {
    if (coupons.length > 0) {
      const initialActiveCoupons = coupons.reduce((acc, coupon) => {
        acc[coupon.id] = false;  // all coupons unselected initially
        return acc;
      }, {});
      setActiveCoupons(initialActiveCoupons);
      calculateTotalDiscount(initialActiveCoupons);
    }
  }, [coupons]);

  const fetchCoupons = async () => {
    try {
      await new Promise(resolve => setTimeout(resolve, 1000));
      setCoupons(mockCoupons);
    } catch (err) {
      console.error('Failed to fetch coupons, using mock data', err);
      setCoupons(mockCoupons);
    } finally {
      setLoading(false);
    }
  };

  const calculateTotalDiscount = (activeCouponState) => {
    const total = coupons.reduce((sum, coupon) => {
      return sum + (activeCouponState[coupon.id] ? coupon.discount : 0);
    }, 0);
    setTotalDiscount(total);
  };

  const toggleCoupon = (id) => {
    const newActiveCoupons = { ...activeCoupons, [id]: !activeCoupons[id] };
    setActiveCoupons(newActiveCoupons);
    calculateTotalDiscount(newActiveCoupons);
  };

  const toggleShowMore = () => {
    setVisibleCoupons(prevVisible =>
      prevVisible === coupons.length ? 2 : coupons.length
    );
  };

  if (loading) return <div className="tour-loading"><Skeleton /></div>;

  return (
    <div class="bg-white" style={{borderRadius: "30px"}}>
      <h2 className="tour-coupons-title">Coupons & Offers</h2>
      <div className="tour-coupons-list">
        {coupons.slice(0, visibleCoupons).map(coupon => (
          <div
            key={coupon.id}
            className={`tour-coupon-item ${activeCoupons[coupon.id] ? 'tour-selected' : ''}`}
          >
            <div className="tour-tour-coupon-info">
              <div className="tour-coupon-details">
                <div className="tour-coupon-code"><span className="tour-coupon-icon"><img src={coupon}></img></span>{coupon.code}</div>
                <div className="tour-coupon-description">{coupon.description}</div>
              </div>
            </div>
            <div className="tour-coupon-discount">
              <p className={`tour-discount-amount ${activeCoupons[coupon.id] ? 'tour-active' : 'tour-inactive'}`}>
                -{coupon.discount.toLocaleString()}
              </p>
              <button
                onClick={() => toggleCoupon(coupon.id)}
                className={`tour-toggle-coupon-button ${activeCoupons[coupon.id] ? 'tour-selected' : ''}`}
              >
                {activeCoupons[coupon.id] ? 'Remove' : 'Apply'}
              </button>
            </div>
          </div>
        ))}
      </div>
      {coupons.length > 2 && (
        <button
          onClick={toggleShowMore}
          className="tour-show-more-button"
        >
          {visibleCoupons === 2 ? (
            <>+{coupons.length - 2} More</>
          ) : (
            <>Show Less</>
          )}
        </button>
      )}
    </div>
  );
};

export default CouponsOffers;
